import cx from "classnames";
import React from "react";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import firebase from "../../utils/firebase";

type JobProps = {
  image: string;
  presentation: string;
  url?: string;
};

const Job: React.FC<JobProps> = ({
  image,
  presentation,
  url,
}: JobProps): React.ReactElement => {
  const [imageSrc, setImageSrc] = React.useState<undefined | string>(undefined);
  const [isShowingJobDetail, setIsShowingJobDetails] = React.useState(false);

  const fetchImageSrc = React.useCallback((): void => {
    if (!firebase) return;
    // Fetch image src
    const storage = getStorage(firebase);
    const imageRef = ref(storage, `assets/${image}.png`);
    getDownloadURL(imageRef)
      .then((src: string) => {
        setImageSrc(src);
        return null;
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error fetching image:", error);
      });
  }, [image]);

  // Set up auth listener and fetch image
  React.useEffect(() => {
    if (!firebase) return;

    // Also listen for auth changes
    const unsubscribe = getAuth(firebase).onAuthStateChanged((user) => {
      if (user) {
        fetchImageSrc();
      }
    });

    return () => unsubscribe();
  }, [fetchImageSrc]);

  const onMouseEnter = React.useCallback(
    (): void => setIsShowingJobDetails(true),
    [],
  );

  const onMouseLeave = React.useCallback(
    (): void => setIsShowingJobDetails(false),
    [],
  );

  return (
    <div
      className={cx(["u-margin-bottom-m", "u-position-relative"])}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {imageSrc && (
        <>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="u-display-block"
          >
            <img
              className={cx(
                "julia-website-portfolio-job-image",
                isShowingJobDetail && "u-opacity-percent-20",
              )}
              src={imageSrc}
              alt={`${presentation} logo`}
            />
          </a>
        </>
      )}
    </div>
  );
};

export default React.memo(Job);
